(function () {
  function wbt() {
    var root = document.getElementById('z3t');
    if (!root) return;

    var wcxSpecKind = null; // 商品説明文の「製品」欄から検出した種別(ring/gem/necklace)

    // 商品種別を解決する共通関数。
    // 優先順位: ①liquidのdata-product-kind（商品タイプ／タグ判定） → ②説明文「製品」欄の判定(wcxSpecKind)
    // → ③商品タイトルの文言からの推測。ここまでで判定できなければ ''（不明）を返す。
    function wcxResolveKind() {
      var attrKind = root.getAttribute('data-product-kind');
      if (attrKind) return attrKind;
      if (wcxSpecKind) return wcxSpecKind;
      var titleEl = document.getElementById('z3g');
      var t = titleEl ? titleEl.textContent : '';
      if (t.indexOf('指輪') !== -1 || t.indexOf('リング') !== -1) return 'ring';
      if (t.indexOf('ネックレス') !== -1 || t.indexOf('ペンダント') !== -1) return 'necklace';
      if (t.indexOf('ルース') !== -1) return 'gem';
      return '';
    }

    (function wa7() {
      var wb8 = document.getElementById('z26');
      var wbr = document.getElementById('z1w');
      var wbs = Array.from(root.querySelectorAll('.z2a'));
      var wb9 = document.getElementById('z2k');
      var war = document.getElementById('z2w');
      var was = document.getElementById('z2v');
      var way = document.getElementById('z31');
      var waz = document.getElementById('z32');
      var wad = Array.from(root.querySelectorAll('.z03'));
      var wax = document.getElementById('z37');
      var wbq = document.getElementById('z3k');
      if (!wb8 || !wb9) return;
      document.body.appendChild(wb9);

      var wz1 = document.getElementById('z2g'); // 拡大画像のラッパー(.z0b)
      var wzMaxScale = 4;
      var wzScale = 1;
      var wzPanX = 0;
      var wzPanY = 0;
      var wzIsPinching = false;
      var wzIsPanning = false;
      var wzPinchStartDist = 0;
      var wzPinchStartScale = 1;
      var wzPinchAnchorX = 0;
      var wzPinchAnchorY = 0;
      var wzPanStartX = 0;
      var wzPanStartY = 0;
      var wzPanOriginX = 0;
      var wzPanOriginY = 0;
      var wzLastTapTime = 0;
      var wzLastTapX = 0;
      var wzLastTapY = 0;
      var wzLastTouchEnd = 0;

      function wzDist(t0, t1) {
        var dx = t0.clientX - t1.clientX;
        var dy = t0.clientY - t1.clientY;
        return Math.sqrt(dx * dx + dy * dy);
      }
      function wzMid(t0, t1) {
        return { x: (t0.clientX + t1.clientX) / 2, y: (t0.clientY + t1.clientY) / 2 };
      }
      function wzMaxPan(scale) {
        var w = war ? war.offsetWidth : 0;
        var h = war ? war.offsetHeight : 0;
        return { x: Math.max(0, (w * (scale - 1)) / 2), y: Math.max(0, (h * (scale - 1)) / 2) };
      }
      function wzClampPan(x, y, scale) {
        var max = wzMaxPan(scale);
        return { x: Math.min(Math.max(x, -max.x), max.x), y: Math.min(Math.max(y, -max.y), max.y) };
      }
      function wzRender() {
        if (!war) return;
        war.style.transform = (wzScale === 1 && wzPanX === 0 && wzPanY === 0)
          ? ''
          : 'translate(' + wzPanX + 'px,' + wzPanY + 'px) scale(' + wzScale + ')';
        if (wz1) wz1.classList.toggle('is-zoomed', wzScale > 1);
      }
      function wzSet(scale, panX, panY) {
        wzScale = Math.min(Math.max(scale, 1), wzMaxScale);
        if (wzScale === 1) { panX = 0; panY = 0; }
        var clamped = wzClampPan(panX, panY, wzScale);
        wzPanX = clamped.x;
        wzPanY = clamped.y;
        wzRender();
      }
      function wzZoomAt(cx, cy, newScale) {
        if (!wz1) return;
        var rect = wz1.getBoundingClientRect();
        var centerX = rect.left + rect.width / 2;
        var centerY = rect.top + rect.height / 2;
        var ox = (cx - centerX - wzPanX) / wzScale;
        var oy = (cy - centerY - wzPanY) / wzScale;
        var panX = (cx - centerX) - ox * newScale;
        var panY = (cy - centerY) - oy * newScale;
        wzSet(newScale, panX, panY);
      }
      function wzApplyScale(s) {
        wzSet(s, wzPanX * (s / (wzScale || 1)), wzPanY * (s / (wzScale || 1)));
      }
      function wzResetZoom() {
        wzSet(1, 0, 0);
      }

      var wav = wbs.length ? wbs.map(function (b) { return b.getAttribute('data-target-src'); }) : (wbr ? [wbr.src] : []);
      var wa6 = wbs.length ? wbs.map(function (b) { return b.getAttribute('data-zoom-src') || b.getAttribute('data-target-src'); }) : wav;
      var waw = 0;

      function wae() {
        if (!wax || !wbq) return;
        var wbn = window.innerWidth > 880;
        var wb1 = wbn ? (wbq.scrollHeight - wbq.clientHeight > 1) : (wbq.scrollWidth - wbq.clientWidth > 1);
        var wcf = wbn ? wbq.scrollTop + wbq.clientHeight : wbq.scrollLeft + wbq.clientWidth;
        var wb2 = wbn ? wbq.scrollHeight : wbq.scrollWidth;
        var wbo = wbn ? wbq.scrollTop : wbq.scrollLeft;
        var wcn = Math.ceil(wcf) >= wb2 - 2;
        var wb3 = wbo <= 2;
        wax.classList.toggle('has-more-right', wb1 && !wcn);
        wax.classList.toggle('has-more-left', wb1 && !wb3);
      }
      if (wbq) {
        wbq.addEventListener('scroll', wae);
        window.addEventListener('resize', wae);
        wae();
      }

      var wao = document.getElementById('z3e');
      var wap = document.getElementById('z3c');
      function wa5(dir) {
        if (!wbq) return;
        var wbn = window.innerWidth > 880;
        if (wbn) {
          var amount = Math.max(wbq.clientHeight * 0.7, 120);
          wbq.scrollBy({ top: dir * amount, behavior: 'smooth' });
        } else {
          var amount = Math.max(wbq.clientWidth * 0.7, 120);
          wbq.scrollBy({ left: dir * amount, behavior: 'smooth' });
        }
      }
      if (wao) wao.addEventListener('click', function (e) { e.stopPropagation(); wa5(-1); });
      if (wap) wap.addEventListener('click', function (e) { e.stopPropagation(); wa5(1); });

      function wac(index) {
        if (wav.length === 0) return;
        wzResetZoom();
        waw = (index + wav.length) % wav.length;
        var newSrc = wav[waw];
        if (wbr) {
          wbr.removeAttribute('srcset');
          wbr.removeAttribute('sizes');
          wbr.src = newSrc;
        }
        wbs.forEach(function (b, i) { b.classList.toggle('is-active', i === waw); });
        if (war) war.src = wa6[waw] || newSrc;
        wad.forEach(function (b, i) { b.classList.toggle('is-active', i === waw); });
        if (wbs[waw] && wbq) {
          var wb4 = wbs[waw];
          var wbn = window.innerWidth > 880;
          if (wbn) {
            var wb5 = wb4.offsetTop - (wbq.clientHeight / 2) + (wb4.clientHeight / 2);
            wbq.scrollTo({ top: wb5, behavior: 'smooth' });
          } else {
            var wbp = wb4.offsetLeft - (wbq.clientWidth / 2) + (wb4.clientWidth / 2);
            wbq.scrollTo({ left: wbp, behavior: 'smooth' });
          }
        }
      }
      wbs.forEach(function (btn, index) { btn.addEventListener('click', function (e) { e.stopPropagation(); wac(index); }); });
      wad.forEach(function (btn, index) { btn.addEventListener('click', function (e) { e.stopPropagation(); wac(index); }); });

      if (war) {
        war.addEventListener('click', function (e) {
          e.stopPropagation();
          if (Date.now() - wzLastTouchEnd < 500) return;
          if (wzScale > 1) {
            wzResetZoom();
          } else {
            wzZoomAt(e.clientX, e.clientY, 2.2);
          }
        });
      }

      if (wz1) {
        wz1.addEventListener('touchstart', function (e) {
          if (e.touches.length === 2) {
            wzIsPinching = true;
            wzIsPanning = false;
            if (war) war.style.transition = 'none';
            wzPinchStartDist = wzDist(e.touches[0], e.touches[1]);
            wzPinchStartScale = wzScale;
            var mid = wzMid(e.touches[0], e.touches[1]);
            var rect = wz1.getBoundingClientRect();
            wzPinchAnchorX = (mid.x - (rect.left + rect.width / 2) - wzPanX) / wzScale;
            wzPinchAnchorY = (mid.y - (rect.top + rect.height / 2) - wzPanY) / wzScale;
          } else if (e.touches.length === 1 && wzScale > 1) {
            wzIsPanning = true;
            if (war) war.style.transition = 'none';
            wzPanStartX = e.touches[0].clientX;
            wzPanStartY = e.touches[0].clientY;
            wzPanOriginX = wzPanX;
            wzPanOriginY = wzPanY;
          }
        }, { passive: true });

        wz1.addEventListener('touchmove', function (e) {
          if (e.touches.length === 2 && wzIsPinching) {
            if (e.cancelable) e.preventDefault();
            var dist = wzDist(e.touches[0], e.touches[1]);
            var ratio = dist / (wzPinchStartDist || dist);
            var newScale = Math.min(Math.max(wzPinchStartScale * ratio, 1), wzMaxScale);
            var mid = wzMid(e.touches[0], e.touches[1]);
            var rect = wz1.getBoundingClientRect();
            var panX = (mid.x - (rect.left + rect.width / 2)) - wzPinchAnchorX * newScale;
            var panY = (mid.y - (rect.top + rect.height / 2)) - wzPinchAnchorY * newScale;
            wzSet(newScale, panX, panY);
          } else if (e.touches.length === 1 && wzIsPanning) {
            if (e.cancelable) e.preventDefault();
            var dx = e.touches[0].clientX - wzPanStartX;
            var dy = e.touches[0].clientY - wzPanStartY;
            wzSet(wzScale, wzPanOriginX + dx, wzPanOriginY + dy);
          }
        }, { passive: false });

        wz1.addEventListener('touchend', function (e) {
          wzLastTouchEnd = Date.now();
          if (e.touches.length < 2) {
            setTimeout(function () { wzIsPinching = false; }, 50);
          }
          if (e.touches.length === 0) {
            wzIsPanning = false;
            if (war) war.style.transition = '';
            if (!wzIsPinching && e.changedTouches && e.changedTouches.length) {
              var t = e.changedTouches[0];
              var now = Date.now();
              var moved = Math.abs(t.clientX - wzLastTapX) > 24 || Math.abs(t.clientY - wzLastTapY) > 24;
              if (now - wzLastTapTime < 320 && !moved) {
                if (wzScale > 1) {
                  wzResetZoom();
                } else {
                  wzZoomAt(t.clientX, t.clientY, 2.2);
                }
                wzLastTapTime = 0;
              } else {
                wzLastTapTime = now;
                wzLastTapX = t.clientX;
                wzLastTapY = t.clientY;
              }
            }
          }
        }, { passive: true });
      }

      var wa0 = 'cb_wishlist_handles';
      function waf() {
        var handle = wb8.querySelector('.cb-wishlist-btn') ? wb8.querySelector('.cb-wishlist-btn').dataset.productHandle : null;
        try {
          var list = JSON.parse(localStorage.getItem(wa0) || '[]');
          var isActive = handle ? list.includes(handle) : false;
          root.querySelectorAll('.cb-wishlist-btn, .z0y').forEach(function (btn) { btn.classList.toggle('active', isActive); });
        } catch (e) {}
      }
      waf();

      var waj = 0, wak = 0, wbj = false;
      wb8.addEventListener('touchstart', function (e) { waj = e.changedTouches[0].screenX; wak = e.changedTouches[0].screenY; wbj = false; }, { passive: true });
      wb8.addEventListener('touchmove', function (e) {
        var dx = e.changedTouches[0].screenX - waj;
        var dy = e.changedTouches[0].screenY - wak;
        if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) {
          wbj = true;
          if (e.cancelable) e.preventDefault();
        }
      }, { passive: false });
      wb8.addEventListener('touchend', function (e) {
        if (!wbj) return;
        var dx = e.changedTouches[0].screenX - waj;
        if (Math.abs(dx) > 40) wac(waw + (dx < 0 ? 1 : -1));
      }, { passive: true });

      function wau(e) {
        if (e.target.closest('.cb-wishlist-btn')) return;
        if (wbj) return;
        if (war && wav.length > 0) {
          war.src = wa6[waw] || wav[waw];
          wad.forEach(function (b, i) { b.classList.toggle('is-active', i === waw); });
          wb9.classList.add('is-open');
          document.body.classList.add('has-lightbox-open');
        }
      }
      function waq(e) {
        if (e) { e.stopPropagation(); e.preventDefault(); }
        wzResetZoom();
        wb9.classList.remove('is-open');
        document.body.classList.remove('has-lightbox-open');
      }
      wb8.addEventListener('click', wau);
      if (was) was.addEventListener('click', waq);
      wb9.addEventListener('click', function (e) {
        var wbi = e.target.closest('#z2g') || e.target.closest('#z1f');
        var wco = e.target.closest('#z31') || e.target.closest('#z32');
        if (!wbi && !wco) waq(e);
      });
      if (way) way.addEventListener('click', function (e) { e.stopPropagation(); wac(waw - 1); });
      if (waz) waz.addEventListener('click', function (e) { e.stopPropagation(); wac(waw + 1); });
      document.addEventListener('keydown', function (e) {
        if (!wb9.classList.contains('is-open')) return;
        if (e.key === 'Escape') waq(e);
        if (e.key === 'ArrowLeft') wac(waw - 1);
        if (e.key === 'ArrowRight') wac(waw + 1);
      });

      var wbg = 0, wb6 = 0, wbh = 0, wb7 = 0;
      wb9.addEventListener('touchstart', function (e) { wbg = e.changedTouches[0].screenX; wbh = e.changedTouches[0].screenY; }, { passive: true });
      wb9.addEventListener('touchend', function (e) {
        if (wzScale > 1 || wzIsPinching) return;
        wb6 = e.changedTouches[0].screenX;
        wb7 = e.changedTouches[0].screenY;
        var wcs = wb6 - wbg, wct = wb7 - wbh;
        if (Math.abs(wcs) > Math.abs(wct) && Math.abs(wcs) > 40) {
          wac(waw + (wcs < 0 ? 1 : -1));
        }
      }, { passive: true });
    })();

    (function wal() {
      var titleEl = document.querySelector('#z3g .z1q');
      if (titleEl) {
        var text = titleEl.innerHTML;
        text = text.replace(/【(.*?)】/g, '<span class="z33 z1b">$1</span>');
        titleEl.innerHTML = text;
      }
    })();

    (function wam() {
      var wa1 = document.getElementById('z2n');
      var wbk = document.getElementById('z21');
      var wa9 = document.getElementById('z2t');
      if (!wa1 || !wbk || !wa9) return;

      // ★修正点(v2): 以前は document.createElement('div') で作った「画面に表示されていない
      //   (DOMツリーに追加されていない)」div に対して .innerText を使って行を取り出していたが、
      //   .innerText はレイアウト計算の結果を返す仕様のため、表示されていない要素に対しては
      //   <p>や<div>の区切りが改行として反映されないことがある（ブラウザ依存の挙動）。
      //   これが「行がくっついてしまう」根本原因だった。
      //   そこで .innerText には頼らず、HTML文字列そのものを見て <br> や </p> 等のタグを
      //   直接 \n に置き換えてからタグを除去する方式に変更し、表示の有無に左右されず
      //   常に安定して1行＝1情報として認識できるようにする。
      function wcxToPlainText(html) {
        if (!html) return '';
        var t = html
          .replace(/<br\s*\/?>/gi, '\n')
          .replace(/<\/(p|div|h1|h2|h3|h4|h5|h6|li|tr)>/gi, '\n')
          .replace(/<[^>]+>/g, '');
        var ta = document.createElement('textarea');
        ta.innerHTML = t;
        return ta.value;
      }

      var wch = wa1.innerHTML;
      var wcg = document.createElement('div');
      wcg.innerHTML = wch;
      var wba = '';
      var wci = wcg.querySelector('table');
      if (wci) {
        wci.querySelectorAll('tr').forEach(function (row) {
          var th = row.querySelector('th') ? wcxToPlainText(row.querySelector('th').innerHTML).trim() : '';
          var td = row.querySelector('td') ? row.querySelector('td').innerHTML.trim() : '';
          if (th.includes('商品説明')) wba = td;
        });
      }
      if (!wba) wba = wcxToPlainText(wch);

      // 商品番号は説明文全体（分割前）から抽出しておく。表形式・本文どちらにも対応。
      var wcaProductNumber = (function () {
        var val = '';
        wcg.querySelectorAll('tr').forEach(function (row) {
          var th = row.querySelector('th') ? wcxToPlainText(row.querySelector('th').innerHTML).trim() : '';
          var td = row.querySelector('td') ? wcxToPlainText(row.querySelector('td').innerHTML).trim() : '';
          if (th.includes('商品番号') || th.includes('管理番号') || th.includes('品番') || th.includes('型番')) val = td;
        });
        if (!val) {
          var m = wcxToPlainText(wch).match(/(?:商品番号|管理番号|品番|型番)\s*[:：]\s*([A-Za-z0-9_-]+)/);
          if (m && m[1]) val = m[1];
        }
        return val;
      })();

      function wcaCleanValue(line) {
        var m = line.match(/[:：]\s*(.+)$/);
        return (m ? m[1] : line).trim();
      }

      if (wba.includes('◎出品詳細')) {
        var parts = wba.split('◎出品詳細');
        var wcb = parts[0].replace(/<br\s*\/?>/gi, '\n').split('\n').map(function (l) { return l.trim(); }).filter(function (l) { return l !== ''; });
        var wat = '';
        var wbv = [];
        wcb.forEach(function (line, index) {
          if (index === 0) {
            wat += '<div class="z0m">' + line + '</div>';
          } else if (line.startsWith('★') || line.startsWith('■') || line.startsWith('【') || line.startsWith('◎')) {
            wat += '<div class="z14">' + line.replace(/[★■【】◎]/g, '') + '</div>';
          } else if (line.startsWith('・') || line.startsWith('-') || line.startsWith('●')) {
            wbv.push(line.substring(1).trim());
          } else {
            if (wbv.length > 0) {
              wat += '<ul class="z25">' + wbv.map(function (i) { return '<li>' + i + '</li>'; }).join('') + '</ul>';
              wbv = [];
            }
            wat += '<p class="z2x">' + line + '</p>';
          }
        });
        if (wbv.length > 0) {
          wat += '<ul class="z25">' + wbv.map(function (i) { return '<li>' + i + '</li>'; }).join('') + '</ul>';
        }
        wbk.innerHTML = wat;

        var wbw = parts[1].replace(/<br\s*\/?>/gi, '\n').split('\n').map(function (l) { return l.trim(); }).filter(function (l) { return l !== ''; });
        var wcc = [];
        wbw.forEach(function (line) {
          if (/^(?:商品番号|管理番号|品番|型番)\s*[:：]/.test(line)) {
            // 商品番号系の行は「号」を含むため寸法/サイズに誤分類されないようここで確定させ、明細テーブルには出さない
            if (!wcaProductNumber) wcaProductNumber = wcaCleanValue(line);
            return;
          } else if (line.includes('ソーティング') || line.includes('鑑別書') || line.includes('鑑定書') || line.includes('保証書')) {
            wcc.push({ group: 'cert', th: '付属品', td: line });
          } else if (line.includes('Gem') || line.includes('AIGS') || line.includes('GIA') || line.includes('機関') || line.includes('中央宝石')) {
            wcc.push({ group: 'cert', th: '鑑別機関', td: line });
          } else if (line.includes('天然') || line.includes('合成')) {
            wcc.push({ group: 'stone', th: '宝石名', td: line });
          } else if (line.includes('ct') || line.includes('カラット')) {
            wcc.push({ group: 'stone', th: '重量', td: line });
          } else if (line.includes('㎜') || line.includes('mm') || line.includes('cm') || line.includes('号')) {
            wcc.push({ group: 'size', th: '寸法 / サイズ', td: line });
          } else if (line.includes('：') || line.includes(':')) {
            var kv = line.split(/[:：]/);
            var kvTh = kv[0].trim(), kvTd = (kv[1] || '').trim();
            wcc.push({ group: 'basic', th: kvTh, td: kvTd });
            if (kvTh.includes('製品')) {
              if (kvTd.includes('指輪') || kvTd.includes('リング')) wcxSpecKind = 'ring';
              else if (kvTd.includes('宝石') || kvTd.includes('ルース')) wcxSpecKind = 'gem';
              else if (kvTd.includes('ネックレス')) wcxSpecKind = 'necklace';
            }
          } else {
            wcc.push({ group: 'other', th: '詳細', td: line });
          }
        });

        var wcaCarat = wcc.filter(function (r) { return r.group === 'stone' && (r.th.includes('重量') || r.th.includes('カラット')); })[0];
        var wcaSize = wcc.filter(function (r) { return r.group === 'size'; })[0];
        var wcaGold = wcc.filter(function (r) { return r.group === 'basic' && r.th.includes('金'); })[0];
        var wceCarat = document.getElementById('cbxMetaCarat');
        var wceSize = document.getElementById('cbxMetaSize');
        var wceGold = document.getElementById('cbxMetaGold');
        var wceProductNo = document.getElementById('cbxMetaProductNo');
        // 指輪(ring)の場合、サイズは「サイズを変更する」ボタンから相談できるため、
        // タイトル直下のメタ表示（例: JP13号 UK53号）は出さない。
        var wcxKindForMeta = wcxResolveKind();
        if (wcaCarat && wceCarat) { wceCarat.textContent = wcaCleanValue(wcaCarat.td); wceCarat.hidden = false; }
        if (wcaSize && wceSize && wcxKindForMeta !== 'ring') { wceSize.textContent = wcaCleanValue(wcaSize.td); wceSize.hidden = false; }
        if (wcaGold && wceGold) { wceGold.textContent = wcaGold.td; wceGold.hidden = false; }
        if (wcaProductNumber && wceProductNo) { wceProductNo.textContent = wcaProductNumber; wceProductNo.hidden = false; }

        var wbb = { cert: '付属品・鑑別', stone: '石の情報', size: 'サイズ', basic: '基本仕様', other: 'その他' };
        var wbl = ['cert', 'stone', 'size', 'basic', 'other'];
        var wcd = '';
        wbl.forEach(function (g) {
          var rows = wcc.filter(function (r) { return r.group === g; });
          if (rows.length === 0) return;
          wcd += '<div class="z1r"><span class="z0d">' + wbb[g] + '</span>';
          if (g === 'basic') {
            wcd += '<div class="z1z">';
            rows.forEach(function (r) { wcd += '<div class="z2d"><span class="label">' + r.th + '</span><span class="value">' + r.td + '</span></div>'; });
            wcd += '</div>';
          } else {
            wcd += '<div class="z2e">';
            rows.forEach(function (r) { wcd += '<div class="z2i"><span class="label">' + r.th + '</span><span class="value">' + r.td + '</span></div>'; });
            wcd += '</div>';
          }
          wcd += '</div>';
        });
        wa9.innerHTML = wcd;
      } else {
        wbk.innerHTML = '<p class="z2x">' + wch + '</p>';
        wa9.innerHTML = '<div class="z1r"><div class="z2e"><div class="z2i"><span class="label">詳細</span><span class="value">商品説明文をご確認ください。</span></div></div></div>';
        var wceProductNoFallback = document.getElementById('cbxMetaProductNo');
        if (wcaProductNumber && wceProductNoFallback) { wceProductNoFallback.textContent = wcaProductNumber; wceProductNoFallback.hidden = false; }
      }
    })();

    (function wan() {
      var wrap = document.getElementById('cbxDescWrap');
      var fade = document.getElementById('cbxDescFade');
      var moreBtn = document.getElementById('cbxDescMore');
      if (!wrap || !moreBtn) return;
      var label = moreBtn.querySelector('.cbx-desc-more-label');
      var expanded = false;
      var LINES_VISIBLE = 4; // 折りたたみ時に見せる行数（写真の見え方に合わせて調整可）

      function wahLineHeight() {
        var target = wrap.querySelector('p, li, div, span') || wrap;
        var cs = window.getComputedStyle(target);
        var lh = parseFloat(cs.lineHeight);
        if (!lh || isNaN(lh)) {
          var fs = parseFloat(cs.fontSize) || 15;
          lh = fs * 1.6;
        }
        return lh;
      }

      function wahCollapse() {
        if (expanded) return;
        var lh = wahLineHeight();
        var collapsedHeight = Math.round(lh * LINES_VISIBLE);
        if (wrap.scrollHeight <= collapsedHeight + 4) {
          wrap.style.maxHeight = 'none';
          if (fade) fade.style.display = 'none';
          moreBtn.style.display = 'none';
          return;
        }
        wrap.style.maxHeight = collapsedHeight + 'px';
        if (fade) { fade.style.display = ''; fade.style.height = Math.round(lh * 1.8) + 'px'; }
        moreBtn.style.display = '';
      }

      moreBtn.addEventListener('click', function () {
        expanded = !expanded;
        moreBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        moreBtn.classList.toggle('is-expanded', expanded);
        if (expanded) {
          wrap.style.maxHeight = wrap.scrollHeight + 'px';
          if (fade) fade.style.display = 'none';
          if (label) label.textContent = '閉じる';
        } else {
          if (label) label.textContent = 'もっと見る';
          wahCollapse();
          wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });

      wahCollapse();
      window.addEventListener('load', wahCollapse);
      var wahResizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(wahResizeTimer);
        wahResizeTimer = setTimeout(wahCollapse, 150);
      });
    })();

    var wcj = document.getElementById('z3d');
    var wbm = null;
    function wbx(msg) {
      if (!wcj) return;
      wcj.textContent = msg;
      wcj.classList.add('is-show');
      clearTimeout(wbm);
      wbm = setTimeout(function () { wcj.classList.remove('is-show'); }, 2400);
    }
    // ページ内の他セクション（おすすめ商品／最近チェックした商品など）からも
    // 同じトーストを呼び出せるよう、グローバルに公開しておく。
    window.cbxShowToast = wbx;

    (function wa8() {
      var form = document.getElementById('z3j');
      if (!form) return;

      var wpData = window.productTemplateData || {};
      var variantId = wpData.variantId;
      var handle = wpData.productHandle;

      var qtyInput = document.getElementById('cbxQty');
      var btnMinus = document.getElementById('cbxQtyMinus');
      var btnPlus = document.getElementById('cbxQtyPlus');
      var addBtn = document.getElementById('z38');
      var msgEl = document.getElementById('z3p');
      var stockLine = document.getElementById('z2m');
      var stockText = document.getElementById('z2p');

      var state = { tracked: false, allowOversell: false, remaining: null, inCart: 0 };

      function setMsg(text, type) {
        if (!msgEl) return;
        msgEl.textContent = text || '';
        msgEl.classList.remove('is-error', 'is-success', 'is-visible');
        if (text) msgEl.classList.add('is-visible', type === 'success' ? 'is-success' : 'is-error');
      }

      function renderStockLine() {
        if (!stockLine || !stockText) return;
        stockLine.classList.remove('is-instock', 'is-lowstock', 'is-outofstock');
        if (!state.tracked || state.allowOversell) {
          stockText.textContent = '在庫あり';
          stockLine.classList.add('is-instock');
          return;
        }
        var remaining = state.remaining;
        if (remaining === null) {
          stockText.textContent = '在庫を確認しています…';
          return;
        }
        if (remaining <= 0) {
          stockText.textContent = state.inCart > 0 ? 'この商品は既にカートに入っています（在庫上限）' : '只今在庫切れです';
          stockLine.classList.add('is-outofstock');
        } else if (remaining <= 3) {
          stockText.textContent = '残り' + remaining;
          stockLine.classList.add('is-lowstock');
        } else {
          stockText.textContent = '在庫あり';
          stockLine.classList.add('is-instock');
        }
      }

      function updateButtonState() {
        var blocked = state.tracked && !state.allowOversell && state.remaining !== null && state.remaining <= 0;
        if (addBtn) { addBtn.disabled = blocked; addBtn.classList.toggle('is-disabled', blocked); }
        if (btnPlus) {
          var qty = parseInt(qtyInput.value, 10) || 1;
          var atMax = state.tracked && !state.allowOversell && state.remaining !== null && qty >= state.remaining;
          btnPlus.disabled = atMax;
        }
      }

      function refreshStockState() {
        if (!handle || !variantId) { renderStockLine(); updateButtonState(); return Promise.resolve(); }
        return Promise.all([
          fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } }),
          fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        ]).then(function (results) {
          return Promise.all([results[0].json(), results[1].json()]);
        }).then(function (data) {
          var product = data[0], cart = data[1];
          var variant = (product.variants || []).find(function (v) { return String(v.id) === String(variantId); });
          var cartLine = (cart.items || []).find(function (i) { return String(i.variant_id) === String(variantId); });
          state.inCart = cartLine ? cartLine.quantity : 0;
          if (variant) {
            state.allowOversell = variant.inventory_policy === 'continue';
            var hasCount = typeof variant.inventory_quantity === 'number';
            state.tracked = hasCount || !variant.available;
            if (hasCount) {
              state.remaining = Math.max(0, variant.inventory_quantity - state.inCart);
            } else if (!variant.available && !state.allowOversell) {
              state.remaining = 0;
            } else {
              state.remaining = null;
            }
          }
        }).catch(function () {
          state.tracked = false;
          state.remaining = null;
        }).then(function () {
          renderStockLine();
          updateButtonState();
        });
      }

      if (btnMinus) btnMinus.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        if (v > 1) qtyInput.value = v - 1;
        updateButtonState();
      });
      if (btnPlus) btnPlus.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        if (state.tracked && !state.allowOversell && state.remaining !== null && v >= state.remaining) {
          setMsg('ご購入可能な数量の上限です（残り' + state.remaining + '点）', 'error');
          return;
        }
        qtyInput.value = v + 1;
        updateButtonState();
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        setMsg('');
        if (addBtn.disabled) return;
        addBtn.disabled = true;
        if (btnPlus) btnPlus.disabled = true;
        if (btnMinus) btnMinus.disabled = true;
        addBtn.classList.add('is-loading');
        var spinner = addBtn.querySelector('.z0h');
        if (spinner) spinner.hidden = false;
        var qty = parseInt(qtyInput.value, 10) || 1;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
        }).then(function (res) {
          return res.json().then(function (data) { return { ok: res.ok, data: data }; });
        }).then(function (result) {
          if (result.ok) {
            setMsg('カートに追加しました。', 'success');
            wbx('カートに追加しました');
            qtyInput.value = 1;
          } else {
            setMsg((result.data && (result.data.description || result.data.message)) || 'カートに追加できませんでした。', 'error');
          }
        }).catch(function () {
          setMsg('通信エラーが発生しました。もう一度お試しください。', 'error');
        }).finally(function () {
          addBtn.classList.remove('is-loading');
          if (spinner) spinner.hidden = true;
          window.dispatchEvent(new CustomEvent('cart:updated'));
          refreshStockState().finally(function () {
            if (btnMinus) btnMinus.disabled = false;
          });
        });
      });

      refreshStockState();
    })();

    (function wcxActionRow() {
      var row = document.getElementById('cbxActionRow');
      if (!row) return;
      var kind = wcxResolveKind();

      var ringSvg = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="12" cy="15" r="6"></circle><path d="M9 9l3-6 3 6"></path></svg>';
      var necklaceSvg = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M4 4c0 6 3.5 10 8 10s8-4 8-10"></path><circle cx="12" cy="17" r="3"></circle></svg>';

      var buttons = [];
      if (kind === 'ring') {
        buttons.push({ label: 'サイズを変更したい', icon: ringSvg, action: 'resize' });
        buttons.push({ label: 'ネックレスに変更したい', icon: necklaceSvg, action: 'remake-necklace' });
      } else if (kind === 'gem') {
        buttons.push({ label: '指輪に変更したい', icon: ringSvg, action: 'remake-ring' });
        buttons.push({ label: 'ネックレスに変更したい', icon: necklaceSvg, action: 'remake-necklace' });
      } else if (kind === 'necklace') {
        buttons.push({ label: '長さを変更したい', icon: necklaceSvg, action: 'resize-necklace' });
        buttons.push({ label: '指輪に変更したい', icon: ringSvg, action: 'remake-ring' });
      } else {
        buttons.push({ label: 'サイズ・仕立て直しのご相談', icon: ringSvg, action: 'consult-general' });
      }

      row.innerHTML = buttons.map(function (b) {
        return '<button type="button" class="cbx-action-btn" data-action="' + b.action + '">' + b.icon + '<span>' + b.label + '</span></button>';
      }).join('');

      row.addEventListener('click', function (e) {
        var btn = e.target.closest('.cbx-action-btn');
        if (!btn) return;
        if (window.cbxOpenLineContact) window.cbxOpenLineContact(btn.dataset.action);
      });
    })();

    (function wcxModal() {
      var modal = document.getElementById('cbxModal');
      if (!modal) return;
      document.body.appendChild(modal);

      var closeBtn = document.getElementById('cbxModalClose');
      var titleEl = document.getElementById('cbxModalTitle');
      var leadEl = document.getElementById('cbxModalLead');
      var productPreview = document.getElementById('cbxModalProduct');
      var productPreviewImg = document.getElementById('cbxModalProductImg');
      var productPreviewTitle = document.getElementById('cbxModalProductTitle');
      var qrImg = document.getElementById('cbxModalQrImg');

      var wpData = window.productTemplateData || {};
      var productTitle = wpData.productTitle || '';

      var LINE_URL = 'https://line.me/R/ti/p/@287mrhcz';
      var QR_SRC = 'https://api.qrserver.com/v1/create-qr-code/?size=220x220&margin=8&data=' + encodeURIComponent(LINE_URL);

      var labels = {
        'resize': { title: 'サイズ変更のご相談', lead: '公式LINEにて、サイズのご相談を承っております。下のQRコードを読み取って友だち追加のうえ、商品とご希望のサイズをお知らせください。' },
        'resize-necklace': { title: '長さ変更のご相談', lead: '公式LINEにて、長さのご相談を承っております。下のQRコードを読み取って友だち追加のうえ、商品とご希望の長さをお知らせください。' },
        'remake-ring': { title: '指輪への変更のご相談', lead: '現在のデザインの石と地金を活かし、指輪にお仕立て直しするご相談です。公式LINEの友だち追加のうえ、商品とご希望内容をお知らせください。' },
        'remake-necklace': { title: 'ネックレスへの変更のご相談', lead: '現在のデザインの石と地金を活かし、ネックレスにお仕立て直しするご相談です。公式LINEの友だち追加のうえ、商品とご希望内容をお知らせください。' },
        'consult-general': { title: 'サイズ・仕立て直しのご相談', lead: 'サイズ調整や指輪／ネックレスへのお仕立て直しなど、公式LINEでお気軽にご相談ください。' }
      };

      function fillProductPreview() {
        if (!productPreview) return;
        var mainImg = document.getElementById('z1w');
        if (productPreviewImg) productPreviewImg.src = mainImg ? mainImg.src : '';
        if (productPreviewTitle) productPreviewTitle.textContent = productTitle;
        productPreview.hidden = !productTitle;
      }

      function isMobileView() {
        return window.matchMedia('(max-width: 880px)').matches;
      }

      window.cbxOpenLineContact = function (action) {
        if (isMobileView()) {
          // スマホ：小窓を出さず、そのままLINEへ遷移
          window.location.href = LINE_URL;
          return;
        }
        // PC：既存の小窓を活かし、QRコードを表示
        var conf = labels[action] || labels['resize'];
        titleEl.textContent = conf.title;
        leadEl.textContent = conf.lead;
        fillProductPreview();
        if (qrImg && qrImg.getAttribute('src') !== QR_SRC) qrImg.src = QR_SRC;
        if (typeof modal.showModal === 'function') {
          modal.showModal();
        } else {
          modal.setAttribute('open', '');
        }
        document.body.classList.add('has-lightbox-open');
      };

      function closeModal() {
        if (typeof modal.close === 'function' && modal.open) {
          modal.close();
        } else {
          modal.removeAttribute('open');
          document.body.classList.remove('has-lightbox-open');
        }
      }

      modal.addEventListener('click', function (e) {
        if (e.target === modal) closeModal();
      });
      modal.addEventListener('close', function () {
        document.body.classList.remove('has-lightbox-open');
      });
      if (closeBtn) closeBtn.addEventListener('click', closeModal);
    })();

    (function wcxTabPlacement() {
      var tabSection = document.getElementById('cbxTabSection');
      var anchor = document.getElementById('cbxTabAnchor');
      var aside = document.getElementById('cbxAside');
      if (!tabSection || !anchor || !aside || !anchor.parentNode) return;

      function apply(isDesktop) {
        if (isDesktop) {
          if (tabSection.parentNode !== aside) aside.appendChild(tabSection);
        } else if (tabSection.nextSibling !== anchor) {
          anchor.parentNode.insertBefore(tabSection, anchor);
        }
      }

      var mq = window.matchMedia('(min-width: 881px)');
      apply(mq.matches);
      if (mq.addEventListener) {
        mq.addEventListener('change', function (e) { apply(e.matches); });
      } else if (mq.addListener) {
        mq.addListener(function (e) { apply(e.matches); });
      }
    })();

    (function wag() {
      var wa0 = 'cb_wishlist_handles';
      root.addEventListener('click', function (e) {
        var btn = e.target.closest('.cb-wishlist-btn, .z0y');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        var handle = btn.dataset.productHandle || (document.querySelector('.cb-wishlist-btn') && document.querySelector('.cb-wishlist-btn').dataset.productHandle);
        if (!handle) return;
        var list = [];
        try { list = JSON.parse(localStorage.getItem(wa0) || '[]'); } catch (err) { list = []; }
        var isActive = list.indexOf(handle) !== -1;
        if (isActive) {
          list = list.filter(function (h) { return h !== handle; });
          wbx('お気に入りから削除しました');
        } else {
          list.push(handle);
          wbx('お気に入りに追加しました');
        }
        try { localStorage.setItem(wa0, JSON.stringify(list)); } catch (err) { console.warn('wishlist: localStorageへの保存に失敗しました', err); }
        root.querySelectorAll('.cb-wishlist-btn, .z0y').forEach(function (b) { b.classList.toggle('active', !isActive); });
        window.dispatchEvent(new CustomEvent('wishlist:updated'));
      });
    })();

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wbt);
  } else {
    wbt();
  }
})();

/* ==========================================================
   最近チェックした商品 ＋ おすすめ商品セクション（cb-reco）
   商品詳細ページ本体(#z3t)とはIDが独立した別セクションのため
   個別のIIFEとして管理。トースト通知は本体側の #z3d を共用する
   （window.cbxShowToast が定義されていればそれを使う）。
========================================================== */
(function () {
  function cbInitReco() {
    var root = document.getElementById('cbReco');
    if (!root) return;

    var WISHLIST_KEY = 'cb_wishlist_handles';
    var RECENT_KEY = 'cb_recently_viewed';
    var RECENT_MAX = 12;

    var currentId = root.dataset.currentId;
    var currentHandle = root.dataset.currentHandle;

    function showToast(msg) {
      if (typeof window.cbxShowToast === 'function') {
        window.cbxShowToast(msg);
      }
    }

    function yen(amount) {
      /* Shopifyの product.price / recommendations API / products.json はいずれも
         金額を「セント単位」の整数で返す（JPYでも同様）。100で割らないと
         実際の価格の100倍で表示されてしまう。 */
      var value = Math.round(Number(amount) / 100);
      return '¥' + value.toLocaleString('ja-JP');
    }

    function escapeHtml(str) {
      if (!str) return '';
      return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    function isWished(handle) {
      try {
        var list = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
        return list.includes(handle);
      } catch (e) { return false; }
    }

    function toggleWish(handle, btn) {
      var list = [];
      try { list = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); } catch (e) {}
      if (list.includes(handle)) {
        list = list.filter(function (h) { return h !== handle; });
        showToast('お気に入りから削除しました');
      } else {
        list.push(handle);
        showToast('お気に入りに追加しました');
      }
      try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) {}
      btn.classList.toggle('active', list.includes(handle));
      window.dispatchEvent(new CustomEvent('wishlist:updated'));
    }

    /* ---- カード生成（リンクのみ／カート追加なし） ---- */
    function cardHtml(p, opts) {
      opts = opts || {};
      var img = p.image || '';
      var hasCompare = p.compare_at_price && Number(p.compare_at_price) > Number(p.price);
      var priceHtml = '<span class="cb-reco-price-tax">税込</span><span class="cb-reco-price">' + yen(p.price) + '</span>'
        + (hasCompare ? '<span class="cb-reco-price-compare">' + yen(p.compare_at_price) + '</span>' : '');
      var badge = '';
      if (opts.recentTag) {
        badge = '<span class="cb-reco-card-recent">最近チェック</span>';
      } else if (!p.available) {
        badge = '<span class="cb-reco-card-badge">SOLD OUT</span>';
      } else if (hasCompare) {
        badge = '<span class="cb-reco-card-sale">SALE</span>';
      }
      var wished = isWished(p.handle);
      var priceBlock = p.available
        ? '<div class="cb-reco-card-price">' + priceHtml + '</div>'
        : '<div class="cb-reco-soldout-tag">SOLD OUT</div>';

      return ''
        + '<a class="cb-reco-card" href="' + p.url + '" data-handle="' + escapeHtml(p.handle) + '">'
        + '<div class="cb-reco-card-imgwrap">'
        + badge
        + '<button type="button" class="cb-reco-wish ' + (wished ? 'active' : '') + '" data-handle="' + escapeHtml(p.handle) + '" aria-label="お気に入りに追加">'
        + '<svg viewBox="0 0 24 24"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>'
        + '</button>'
        + (img ? '<img src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy" decoding="async">' : '')
        + '<div class="cb-reco-card-veil"><span class="cb-reco-card-viewlabel">'
        + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"></circle><path d="M9 12l2 2 4-4"></path></svg>'
        + '詳しく見る</span></div>'
        + '</div>'
        + '<div class="cb-reco-card-body">'
        + '<span class="cb-reco-card-title">' + escapeHtml(p.title) + '</span>'
        + priceBlock
        + '</div>'
        + '</a>';
    }

    function renderTrack(trackId, products, opts) {
      var track = document.getElementById(trackId);
      if (!track) return;
      track.innerHTML = '';
      products.forEach(function (p, i) {
        var wrap = document.createElement('div');
        wrap.innerHTML = cardHtml(p, opts);
        var card = wrap.firstChild;
        card.style.animationDelay = (i * 60) + 'ms';
        track.appendChild(card);
      });
      updateNavVisibility(track);
    }

    function updateNavVisibility(track) {
      var prevBtn = root.querySelector('.cb-reco-nav--prev[data-track="' + track.id + '"]');
      var nextBtn = root.querySelector('.cb-reco-nav--next[data-track="' + track.id + '"]');
      if (!prevBtn || !nextBtn) return;
      var atStart = track.scrollLeft <= 4;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      prevBtn.classList.toggle('is-hidden', atStart);
      nextBtn.classList.toggle('is-hidden', atEnd || track.scrollWidth <= track.clientWidth);
    }

    Array.prototype.forEach.call(root.querySelectorAll('.cb-reco-track'), function (track) {
      track.addEventListener('scroll', function () { updateNavVisibility(track); });
      window.addEventListener('resize', function () { updateNavVisibility(track); });
    });
    Array.prototype.forEach.call(root.querySelectorAll('.cb-reco-nav'), function (btn) {
      btn.addEventListener('click', function () {
        var track = document.getElementById(btn.dataset.track);
        if (!track) return;
        var dir = btn.classList.contains('cb-reco-nav--prev') ? -1 : 1;
        track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
      });
    });

    /* ---- お気に入りクリック（カード全体のリンク遷移は阻止） ---- */
    root.addEventListener('click', function (e) {
      var wishBtn = e.target.closest('.cb-reco-wish');
      if (wishBtn) {
        e.preventDefault();
        e.stopPropagation();
        toggleWish(wishBtn.dataset.handle, wishBtn);
      }
    });

    /* ---- 最近チェックした商品：記録＆表示 ---- */
    function loadRecent() {
      try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) { return []; }
    }
    function saveRecent(list) {
      localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, RECENT_MAX)));
    }
    function recordCurrentProduct() {
      if (!currentHandle) return;
      var list = loadRecent();
      list = list.filter(function (p) { return p.handle !== currentHandle; });
      list.unshift({
        handle: currentHandle,
        title: root.dataset.currentTitle,
        url: root.dataset.currentUrl,
        image: root.dataset.currentImage,
        price: root.dataset.currentPrice,
        compare_at_price: root.dataset.currentCompare,
        available: root.dataset.currentAvailable === 'true'
      });
      saveRecent(list);
    }
    function renderRecent() {
      var block = document.getElementById('cbRecentBlock');
      var list = loadRecent().filter(function (p) { return p.handle !== currentHandle; });
      if (!block) return;
      if (list.length === 0) { block.hidden = true; return; }
      block.hidden = false;
      renderTrack('cbRecentTrack', list, { recentTag: true });
    }

    recordCurrentProduct();
    renderRecent();

    /* ---- レコメンド取得（related → 空なら complementary にフォールバック） ---- */
    function normalizeProduct(p) {
      return {
        handle: p.handle,
        title: p.title,
        url: p.url,
        image: p.featured_image || (p.images && p.images[0]) || '',
        price: p.price,
        compare_at_price: p.compare_at_price,
        available: p.available
      };
    }
    function fetchRecommendations(intent) {
      var url = '/recommendations/products.json?product_id=' + encodeURIComponent(currentId) + '&limit=8&intent=' + intent;
      return fetch(url, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
    }

    var emptyEl = document.getElementById('cbRecoEmpty');
    var suggestTrackWrap = document.querySelector('#cbSuggestBlock .cb-reco-track-wrap');

    fetchRecommendations('related').then(function (data) {
      var products = (data && data.products) || [];
      if (products.length === 0) {
        return fetchRecommendations('complementary').then(function (data2) {
          return (data2 && data2.products) || [];
        });
      }
      return products;
    }).then(function (products) {
      if (products.length === 0) {
        if (suggestTrackWrap) suggestTrackWrap.hidden = true;
        if (emptyEl) emptyEl.hidden = false;
        return;
      }
      renderTrack('cbRecoTrack', products.map(normalizeProduct), {});
    }).catch(function () {
      if (suggestTrackWrap) suggestTrackWrap.hidden = true;
      if (emptyEl) {
        emptyEl.hidden = false;
        emptyEl.textContent = 'おすすめ商品の読み込みに失敗しました。';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cbInitReco);
  } else {
    cbInitReco();
  }
})();